import styles from "./GridLoadMoreButton.module.scss";
import { useGrid } from "../Grid";
import { Button } from "@/components/Global/Button/Button";
import { useGlobalContext } from "@aleksundshantu.com/aunds-utils-react/contexts";

type GridLoadMoreButtonProps = { hoverStyle: "white" | "pistachio" };

export const GridLoadMoreButton = ({ hoverStyle }: GridLoadMoreButtonProps) => {
  const { getLabel } = useGlobalContext();
  const { loading, handleLoadMore, canLoadMore } = useGrid();

  if (!canLoadMore) return null;

  return (
    <Button
      className={`${styles["load-more-button"]} ${styles[`hover-style-${hoverStyle}`]}`}
      type="primary"
      href="#"
      target={""}
      onClick={handleLoadMore}
      noIcon={loading}
      icon={"circlePlus"}
    >
      {loading
        ? getLabel("load_more_btn_loading_label")
        : getLabel("load_more_recipe_grid_label")}
    </Button>
  );
};
